import React, { useEffect, useState, useRef } from 'react';
import './solutions/Solutions.css'; // you can style it here
import { getDocs, collection, query, orderBy, where } from 'firebase/firestore';
import { db } from '../firebase'; // adjust based on your structure
import FeaturedCardsSection from "../components/FeaturedCardsSection";
import TradeshowGrid from "../components/tradeshowGrid";

const slides = [
  {
    video: "",
    poster: "/videos/NewsBackground.png",
    heading: "Updates, breakthroughs, and insights in optics​",
    subheading: "News, articles, and blogs from the team",
    buttonLink: ""
  }
];

const makeKnowledgeCenterDocSlug = (fileNameOrPath = "") => {
  const fileName = fileNameOrPath.split("/").pop() || fileNameOrPath;

  return fileName
    .replace(/\.[^/.]+$/, "")      // remove .pdf
    .toLowerCase()
    .replace(/[^a-z0-9]+/g, "-")   // replace dots, spaces, symbols with -
    .replace(/^-+|-+$/g, "");      // trim starting/ending -
};

const formatDisplayDate = (dateString = "") => {
  if (!dateString) return "";

  const date = new Date(`${dateString}T00:00:00`);

  if (Number.isNaN(date.getTime())) return "";

  const day = date.getDate();

  const suffix =
    day % 10 === 1 && day !== 11
      ? "st"
      : day % 10 === 2 && day !== 12
        ? "nd"
        : day % 10 === 3 && day !== 13
          ? "rd"
          : "th";

  const month = date.toLocaleString("en-US", { month: "long" });
  const year = date.getFullYear();

  return `${month} ${day}${suffix}, ${year}`;
};

const formatCardDescription = (dateString = "", description = "") => {
  const formattedDate = formatDisplayDate(dateString);

  if (formattedDate && description) {
    return `${formattedDate} - ${description}`;
  }

  return description || formattedDate || "";
};

const brandGuide = [
  {
  name: 'Brand Guide',
  link: 'https://firebasestorage.googleapis.com/v0/b/gofoton-55796.firebasestorage.app/o/other%2FGo!Foton%20Brand%20Guidelines.pdf?alt=media&token=562a164f-2110-441a-b6d1-9ff53371cc30'
},
{
  name: 'Company Description',
  link: '/decoding-the-gofoton-brand/'
},
{
  name: 'Logo',
  link: 'https://firebasestorage.googleapis.com/v0/b/gofoton-55796.firebasestorage.app/o/stockImages%2FGoFoton%20Logo.png?alt=media&token=752e6ff9-fc99-41bc-8074-2eaa74451894'
},
{
  name: 'Media Contact',
  link: 'mailto:brand@gofoton.com'
},

]



const articles = [
    {
    headline: "CEO Simin Cai: When Founders Need To Get Out Of Their Own Way",
    body: "March 20, 2026 – When you start a company, some part of your personal identity has to be embedded in it, because that’s the fuel to get the startup off the ground.",
    link: "https://www.forbes.com/councils/forbesbusinesscouncil/2026/03/20/when-founders-need-to-get-out-of-their-own-way/",
    logo: "images/newsLogos/Forbes.png"
  },
  {
    headline: "CEO Simin Cai: How I navigate uncertainty: A strategy for survival and sanity",
    body: "July 23, 2025 – In uncertain markets, survival is the first strategy. When I’m facing volatility—especially the kind we’re seeing now—I look for something I can count on.",
    link: "https://www.fastcompany.com/91356114/how-i-navigate-uncertainty-a-strategy-for-survival-and-sanity",
    logo: "/images/newsLogos/fastCompany.jpg"
  },
  {
    headline: "Fiber Optic Sensing Association Elects Dynamic 2025 Leadership Team to Drive Industry Innovation",
    body: "January 9, 2025 – The Fiber Optic Sensing Association (FOSA), the nation's premier trade association dedicated to fiber optic sensing, today announced an accomplished slate of officers and board members for 2025.",
    link: "https://fiberopticsensing.org/2025/01/08/fosa-elects-dynamic-2025-leadership-team-to-drive-industry-innovation/",
    logo: "/images/newsLogos/fiberOpticAssociation.png"
  },
  {
    headline: "Go!Foton is the 2024 Sensing in Telecom Award winner",
    body: "January 9, 2025 – This award recognizes our groundbreaking technology invention for Triplet Duality of DAS/P-OTDR/OPM and pending new product.",
    link: "https://fiberopticsensing.org/fosa-awards/",
    logo: "/images/newsLogos/fiberOpticAssociation.png"
  },
  {
    headline: "Edge Of Greatness: Go!Foton's PEACOC Family Solves ISP & OSP Fiber Densification Challenges Created by R-PHY Deployment",
    body: "September 20, 2022 – Somerset, NJ-based Go!Foton, a world leader in optical networking solutions for carriers, MSOs, and data centers, is showcasing recent additions to its trailblazing PEACOC family...",
    link: "https://www.einpresswire.com/article/591751925/edge-of-greatness-go-foton-s-peacoc-family-solves-isp-osp-fiber-densification-challenges-created-by-r-phy-deployment?r=paR4wNxXCKsuvFCBGj",
    logo: "/images/newsLogos/einNewsDesk.png"
  },
  {
    headline: "Furukawa signs an agreement to distribute Go!Foton products in Latin America.",
    body: "Furukawa Electric LatAm will offer connectivity solutions from Go!Foton, a manufacturer of connectivity components for data centers and optical networks, to 21 countries in Central and South America.",
    link: "https://esemanal.mx/2020/10/furukawa-firma-un-acuerdo-para-distribuir-productos-de-gofoton-en-latinoamerica/",
    logo: "/images/newsLogos/3.png"
  },
  {
    headline: "COVID-19 crisis management for photonics businesses",
    body: "Innovation and leadership will be the keys to successful short- and long-term responses to the pandemic.",
    link: "https://www.laserfocusworld.com/blogs/article/14174038/crisis-management-experience-can-help-guide-the-photonics-community-through-the-covid19-pandemic",
    logo: "/images/newsLogos/laserFocusWorld.png"
  },
  {
    headline: "Fiber Densification: Go!Foton Rises To The Challenge",
    body: "There are a number of factors driving fiber densification globally, not the least of which is 5G, and it is something which will only increase over time.",
    link: "https://online.flippingbook.com/view/543914/20/",
    logo: "/images/newsLogos/oc.png"
  },
  {
    headline: "High density fiber management critical as Europe looks to break 200 million FTTH homes by 2020",
    body: "Go!Foton welcomes the latest FTTH Council New Fiber Market Panorama but calls for Intelligent Fiber Management (IFM) to support hard-pressed Telecoms operators amid boom in home working and Data Center growth.",
    link: "https://totaltele.com/high-density-fiber-management-critical-as-europe-looks-to-break-200-million-ftth-homes-by-2021-says-gofoton/",
    logo: "/images/newsLogos/totalTelecom.png"
  },
  {
    headline: "Go!Foton Showcases Versatility At Fiber Connect 2022 With Enhancements To PEACOC® Platform and NEMO Patch Panel",
    body: "NASHVILLE, TN, US, June 13, 2022 /EINPresswire.com/ — Go!Foton Showcases Versatility At Fiber Connect 2022 With Enhancements To Flagship PEACOC® Fiber Management Platform and NEMO Patch Panel.",
    link: "https://www.einnews.com/amp/pr_news/576477579/go-foton-showcases-versatility-at-fiber-connect-2022-with-enhancements-to-peacoc-platform-and-nemo-patch-panel",
    logo: "/images/newsLogos/einNewsDesk.png"
  },
];




function News() {

    const [showPopup, setShowPopup] = useState(false);

  const [products, setProducts] = useState([]);
const [filteredProducts, setFilteredProducts] = useState([]);
const [activeFilter, setActiveFilter] = useState('All');

const [startIndex, setStartIndex] = useState(0);

const [isMobile, setIsMobile] = useState(window.innerWidth <= 768);

const [articleIndex, setArticleIndex] = useState(0);
const [newsIndex, setNewsIndex] = useState(0);
const [contentSlidesPerView, setContentSlidesPerView] = useState(3);

const [pressReleases, setPressReleases] = useState([]);
const [loadingPressReleases, setLoadingPressReleases] = useState(true);
const [firebaseArticles, setFirebaseArticles] = useState([]);
const [loadingArticles, setLoadingArticles] = useState(true);

useEffect(() => {
  const updateSlidesPerView = () => {
    if (window.innerWidth <= 768) {
      setContentSlidesPerView(1);
    } else if (window.innerWidth <= 1100) {
      setContentSlidesPerView(2);
    } else {
      setContentSlidesPerView(3);
    }
  };

  updateSlidesPerView();
  window.addEventListener("resize", updateSlidesPerView);

  return () => window.removeEventListener("resize", updateSlidesPerView);
}, []);

useEffect(() => {
  const loadPressReleases = async () => {
    setLoadingPressReleases(true);

    try {
      const q = query(
        collection(db, "documentMetadata"),
        where("type", "==", "pressRelease")
      );

      const snap = await getDocs(q);

      const rows = snap.docs
        .map((docSnap) => {
          const data = docSnap.data();

            const docSlug = makeKnowledgeCenterDocSlug(
              data.fileName || data.storagePath || docSnap.id
            );

            return {
              id: docSnap.id,
              headline: data.title || "",
              body: data.description || "",
              link: `/knowledge-center?doc=${docSlug}`,
              date: data.date || "",
              storagePath: data.storagePath || "",
            };
        })
        .filter((item) => item.headline && item.link)
        .sort((a, b) => {
          return new Date(b.date || "1900-01-01") - new Date(a.date || "1900-01-01");
        });

      console.log("Loaded press releases:", rows);

      setPressReleases(rows);
    } catch (err) {
      console.error("Error loading press releases:", err);
      setPressReleases([]);
    } finally {
      setLoadingPressReleases(false);
    }
  };

  loadPressReleases();
}, []);


useEffect(() => {
  const loadArticles = async () => {
    setLoadingArticles(true);

    try {
      const q = query(
        collection(db, "documentMetadata"),
        where("type", "==", "article")
      );

      const snap = await getDocs(q);

      const rows = snap.docs
        .map((docSnap) => {
          const data = docSnap.data();

          return {
            id: docSnap.id,
            headline: data.title || "",
            body: data.description || "",
            link: data.link || "",
            logo: data.logo || "",
            date: data.date || "",
          };
        })
        .filter((item) => item.headline && item.link)
        .sort((a, b) => {
          return new Date(b.date || "1900-01-01") - new Date(a.date || "1900-01-01");
        });

      console.log("Loaded articles:", rows);

      setFirebaseArticles(rows);
    } catch (err) {
      console.error("Error loading articles:", err);
      setFirebaseArticles([]);
    } finally {
      setLoadingArticles(false);
    }
  };

  loadArticles();
}, []);

const displayedArticles = firebaseArticles;
const displayedNews = pressReleases;

const articleMaxIndex = Math.max(displayedArticles.length - contentSlidesPerView, 0);
const newsMaxIndex = Math.max(displayedNews.length - contentSlidesPerView, 0);

const nextArticle = () => {
  setArticleIndex((prev) => Math.min(prev + 1, articleMaxIndex));
};

const prevArticle = () => {
  setArticleIndex((prev) => Math.max(prev - 1, 0));
};

const nextNews = () => {
  setNewsIndex((prev) => Math.min(prev + 1, newsMaxIndex));
};

const prevNews = () => {
  setNewsIndex((prev) => Math.max(prev - 1, 0));
};

useEffect(() => {
  if (articleIndex > articleMaxIndex) {
    setArticleIndex(articleMaxIndex);
  }
}, [articleIndex, articleMaxIndex]);

useEffect(() => {
  if (newsIndex > newsMaxIndex) {
    setNewsIndex(newsMaxIndex);
  }
}, [newsIndex, newsMaxIndex]);

useEffect(() => {
  const handleResize = () => {
    setIsMobile(window.innerWidth <= 768);
  };
  window.addEventListener("resize", handleResize);
  console.log('isMobile?', isMobile)
  return () => window.removeEventListener("resize", handleResize);
}, []);

  const next = () => {
    if (startIndex + 3 < articles.length) {
      setStartIndex(startIndex + 1);
    }
  };

  const prev = () => {
    if (startIndex > 0) {
      setStartIndex(startIndex - 1);
    }
  };


const productFamilies = [
  'Fiber Cable Assemblies',
  'Passive Optical Components',
  'Cassettes',
  'Fiber Panels',
  'Frames',
];

const facts = [
    { label: "Years of in-house manufacturing", value: 25, prefix: "", suffix: "+", key: "years" },
    { label: "Continents with operations", value: 3, prefix: "", suffix: "", key: "continents" },
    { label: "employees dedicated to your needs", value: 2000, prefix: "~", suffix: "", key: "employees" },
    { label: "on-time delivery", value: 95, prefix: ">", suffix: "%", key: "delivery" },
  ];

  const [counts, setCounts] = useState({
    years: 0,
    continents: 0,
    employees: 0,
    delivery: 0,
  });

  useEffect(() => {
    const animationFrames = {};
    const durations = 600; // in ms

    facts.forEach(fact => {
      const start = performance.now();

      const animate = now => {
        const progress = Math.min((now - start) / durations, 1);
        const currentValue = Math.floor(progress * fact.value);

        setCounts(prev => ({
          ...prev,
          [fact.key]: currentValue,
        }));

        if (progress < 1) {
          animationFrames[fact.key] = requestAnimationFrame(animate);
        }
      };

      animationFrames[fact.key] = requestAnimationFrame(animate);
    });

    return () => {
      Object.values(animationFrames).forEach(cancelAnimationFrame);
    };
  }, []);

  const [industryFilter, setIndustryFilter] = useState('Central Office & Headends')

useEffect(() => {
  const loadProducts = async () => {
    const querySnapshot = await getDocs(collection(db, 'products'));
    const allProducts = querySnapshot.docs
      .map(doc => ({ id: doc.id, ...doc.data() }))
      .filter(p => (p["Include Y or N"] || '').trim().toUpperCase() !== 'N');

    setProducts(allProducts);
    setFilteredProducts(allProducts); // Default to all
  };

  loadProducts();
}, []);




useEffect(() => {
  if (activeFilter === 'All') {
    setFilteredProducts(products);
  } else {
    setFilteredProducts(products.filter(p => p.productFamily === activeFilter));
  }
}, [activeFilter, products]);

  return (
    <div className="contact-page">
      <div className="single-marquee">
        <div className="single-marquee-slide">
          <video
          controls disablePictureInPicture controlsList="nodownload nofullscreen noremoteplayback"
            src={slides[0].video}
            poster={slides[0].poster}
            autoPlay
            loop
            muted
            playsInline
          />
          <div className="single-overlay-content">
            <h1>{slides[0].heading}</h1>
            <p>{slides[0].subheading}</p>
          </div>
        </div>
      </div>

      <svg className="section-divider" viewBox="0 0 1440 150" preserveAspectRatio="none">
  <defs>
    <linearGradient id="hardWhiteSplit" x1="0" y1="0" x2="0" y2="1">
      <stop offset="50%" stopColor="white" stopOpacity="1" />
    </linearGradient>
  </defs>
  <path
    d="
      M0,150
      H1440
      V0
      Q720,75 0,0
      Z
    "
    fill="url(#hardWhiteSplit)"
  />
</svg>

<FeaturedCardsSection
  variant="news"
  isMobile={isMobile}
  showSeparateHeadings={true}
/>



      <div className="solutions-section-centeredText">
        <div className="solutions-section-centeredText-text-container">
          <h2 className="solutions-section-centeredText-subheading">Articles</h2>

{loadingArticles && (
  <p>Loading articles...</p>
)}

{!loadingArticles && displayedArticles.length === 0 && (
  <p>No articles are currently available.</p>
)}

{!loadingArticles && displayedArticles.length > 0 && (
<div className="article-slider-container">
  {displayedArticles.length > contentSlidesPerView && (
    <button
      className={`chevron chevron-left ${articleIndex === 0 ? "disabled" : ""}`}
      onClick={prevArticle}
      disabled={articleIndex === 0}
      aria-label="Previous articles"
      type="button"
    >
      &#10094;
    </button>
  )}

  <div className="article-slider-viewport">
    <div
      className="article-slider-track"
      style={{
        transform: `translateX(-${articleIndex * (100 / contentSlidesPerView)}%)`,
        "--content-slides-per-view": contentSlidesPerView,
      }}
    >
      {displayedArticles.map((article, idx) => (
        <div className="article-slider-slide" key={idx}>
          <div className="article-slider-card">
            <div className="article-logo-wrapper">
              <img src={article.logo} alt="logo" className="article-logo" />
            </div>
            <h3><b>{article.headline}</b></h3>
            <p>{formatCardDescription(article.date, article.body)}</p>
            <a
              className="cta-button"
              href={article.link}
              target="_blank"
              rel="noopener noreferrer"
              style={{ textDecoration: "none" }}
            >
              View
            </a>
          </div>
        </div>
      ))}
    </div>
  </div>

  {displayedArticles.length > contentSlidesPerView && (
    <button
      className={`chevron chevron-right ${articleIndex === articleMaxIndex ? "disabled" : ""}`}
      onClick={nextArticle}
      disabled={articleIndex === articleMaxIndex}
      aria-label="Next articles"
      type="button"
    >
      &#10095;
    </button>
  )}
</div>
)}
    </div>
    </div>


      <div className="solutions-section-centeredText-news" style={{ position: 'relative'}}>

        <div className="curved-divider-top" />

        <div className="solutions-section-centeredText-text-container">
          <h2 className="solutions-section-centeredText-subheading" style={{ color: 'black'}}>News</h2>

{loadingPressReleases && (
  <p style={{ color: "black" }}>Loading news...</p>
)}

{!loadingPressReleases && displayedNews.length === 0 && (
  <p style={{ color: "black" }}>
    No press releases are currently available.
  </p>
)}
{!loadingPressReleases && displayedNews.length > 0 && (
  <div className="article-slider-container">
<div className="article-slider-container">
  {displayedNews.length > contentSlidesPerView && (
    <button
      className={`chevron chevron-left ${newsIndex === 0 ? "disabled" : ""}`}
      onClick={prevNews}
      disabled={newsIndex === 0}
      aria-label="Previous news"
      type="button"
    >
      &#10094;
    </button>
  )}

  <div className="article-slider-viewport">
    <div
      className="article-slider-track"
      style={{
        transform: `translateX(-${newsIndex * (100 / contentSlidesPerView)}%)`,
        "--content-slides-per-view": contentSlidesPerView,
      }}
    >
      {displayedNews.map((article, idx) => (
        <div className="article-slider-slide" key={idx}>
          <div className="article-slider-card">
            <h3><b>{article.headline}</b></h3>
            <p>{formatCardDescription(article.date, article.body)}</p>
            <a
              className="cta-button"
              href={article.link}
              target='blank'
              style={{ textDecoration: "none" }}
            >
              View
            </a>
          </div>
        </div>
      ))}
    </div>
  </div>

 {displayedNews.length > contentSlidesPerView && (
    <button
      className={`chevron chevron-right ${newsIndex === newsMaxIndex ? "disabled" : ""}`}
      onClick={nextNews}
      disabled={newsIndex === newsMaxIndex}
      aria-label="Next news"
      type="button"
    >
      &#10095;
    </button>
  )}
</div>

    </div>
)}
    <div className="curved-divider-bottom" />

    </div>
</div>

      <div id="events" className="solutions-section-centeredText">
        <div className="solutions-section-centeredText-text-container">
          <h2 className="solutions-section-centeredText-subheading">Trade Shows & Events</h2>
          <p className="solution-section-centeredText-description">We invite you to see us at upcoming events.</p>
          <TradeshowGrid />
        </div>
      </div>



      <div id="demos" className="solutions-section-centeredText">
        

        <div className="solutions-section-centeredText-container">
          <div className="solutions-section-1-image-container-wide">
          <img src="/images/mobileUnit.jpg" alt="Mobile Unit" />
        </div>

          <h2 className="ssolutions-section-centeredText-subheading">We can bring the show to you</h2>
          <p className="ssolutions-section-centeredText-description" style={{ marginBottom: 40, marginTop: 20, fontSize: 20, color: '#4D4D4F'}}>If you’d like a hands-on look at our latest products and solutions, let us know! Our <a href="http://gofoton.com/knowledge-center?doc=gofoton-mobile-vehicle-brochure">mobile demo trailer</a> is at-the-ready to bring Go!Foton to your front door. Fully equipped with optical solutions for the data center to the network edge, you’ll see how feature-rich and user-friendly the solutions are.​</p>
        <a
              className="cta-button"
              href="/support"
            >
              Request a Visit
            </a>
        </div>
      </div>


          <div className="solutions-section-centeredText">
        <div className="solutions-section-centeredText-text-container">
          <h2 className="solutions-section-centeredText-subheading">Brand Center</h2>
          <p className="solution-section-centeredText-description" style={{color: '#4D4D4F'}}>Check out our resources for media, analyst, and partners. Can’t find what you’re looking for?​</p>
       
       <div className="brand-grid-wrapper" style={{marginTop: 30}}>
{brandGuide.map((item, i) => (
  <div className="brand-grid-card" key={i}>
    <p style={{ paddingBottom: 20}}>{item.name}</p>
    {item.name === 'Company Description' ? (
      <a className="cta-button" onClick={() => setShowPopup(true)}>
        CLICK HERE
      </a>
    ) : 
    <a href={item.link} style={{textDecoration: 'none'}} className="cta-button" target="_blank" rel="noopener noreferrer">
      Click Here
    </a>}
  </div>
))}

    </div>

{showPopup && (
        <div className="popup-overlay" onClick={() => setShowPopup(false)}>
          <div className="popup-content" onClick={(e) => e.stopPropagation()}>
            <p>
              Based in the USA with teams around the world, Go!Foton is at the forefront of advanced
              optical and photonics innovation. We engineer solutions to enhance user experience by
              offering customers unique approaches to solve real-world problems in connectivity,
              imaging, and beyond.
              <br /><br />
              Go!Foton technology stands apart with feature-rich and performance-optimized solutions.
              We keep our customers satisfied and businesses performing, ensuring new and improved
              experiences for all.
              <br /><br />
              Inspired by nature and physics, the sky is the limit when imagining what’s possible and
              creating what’s next.
              <br /><br />
              Discover new dimensions at gofoton.com.
            </p>
          </div>
        </div>
      )}
              {/* <a href="mailto:brand@gofoton.com" style={{ textDecoration: 'none'}}  className='cta-button'>Reach Out</a> */}

        </div>
        </div>

        <div className="curved-footer-solutions">
        <div className="curved-top-overlay"></div>
        
        <h2>Would you like to hear more?</h2>
        <p>Our experts would love to hear about your systems and how we can help</p>
        <a className="connect-button" href="/support">LET’S CONNECT</a>
        </div>

    </div>

  );
}

export default News;
